import React, { useEffect, useState } from "react";
import { Dropdown, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { getEpisodes } from "../../apis/episode";
import CommonPagination from "../../components/CommanPagination";

const EpisodeList = () => {
  const navigate = useNavigate();
  const [episodes, setEpisodes] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>();

  const fetchEpisodes = (params: any = {}) => {
    getEpisodes(params).then((res: any) => {
      setEpisodes(res.data?.data || res.data || []);
      setMeta(res.data?.meta || null);
    });
  };

  useEffect(() => {
    fetchEpisodes({ per_page: 10 });
  }, []);

  const onPaginationChange = (page: number, pageSize?: number) => {
    fetchEpisodes({ page, per_page: pageSize || 10 });
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Episodes
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            All patient episodes with types and status.
          </p>
        </div>
      </div>

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                      Patient
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Episode Type
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Visits
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Status
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Created At
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {episodes.length > 0 ? (
                    episodes.map((episode) => (
                      <tr key={episode.id}>
                        <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                          {episode.patient
                            ? `${episode.patient.fullName}`.trim()
                            : "-"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          {episode.episodeType?.name || "-"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          {episode.visitCount ?? episode.visits?.length ?? 0}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500 capitalize">
                          {episode.status || "-"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          {episode.createdAt
                            ? new Date(episode.createdAt).toLocaleString()
                            : "-"}
                        </td>
                        <td className="py-4 px-3 text-sm text-gray-500">
                          <Dropdown
                            menu={{
                              items: [
                                {
                                  key: "create-visit",
                                  label: (
                                    <span
                                      onClick={() => {
                                        const patientId =
                                          episode.patientId || episode.patient?.id;
                                        if (patientId) {
                                          navigate(`/patients/${patientId}/visits/types`);
                                        }
                                      }}
                                    >
                                      Create Visit
                                    </span>
                                  ),
                                },
                                {
                                  key: "view-visits",
                                  label: (
                                    <span
                                      onClick={() => {
                                        navigate(`/episodes/${episode.id}/visits`);
                                      }}
                                    >
                                      View Visits
                                    </span>
                                  ),
                                },
                              ],
                            }}
                            placement="bottomLeft"
                          >
                            <Button>Actions</Button>
                          </Dropdown>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={6}
                        className="py-4 pr-3 pl-4 text-sm font-medium text-gray-900 sm:pl-6"
                      >
                        Record Not Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpisodeList;
